import styled from '@emotion/styled';
import { Alert, tokens } from '@hotjar/hotsauce';
import { useTranslation } from 'react-i18next';

const AlertContent = styled.div`
  display: inline-flex;
  margin-bottom: ${tokens.spacer.x2};
`;

export interface InfoAlertProps {
  questionCount: number | undefined;
  isRestricted: boolean;
  isSupportedDateRange: boolean;
  onUpsell: () => void;
}

export const InfoAlert = ({
  questionCount,
  isRestricted,
  onUpsell,
  isSupportedDateRange,
}: InfoAlertProps): JSX.Element | null => {
  const { t } = useTranslation('feedback', { keyPrefix: 'surveys.performance.alerts' });

  if (questionCount === undefined) return null;

  const canUpsell = isRestricted && questionCount > 1;
  const tooFewQuestion = questionCount < 2;

  const getInfoMessage = () => {
    if (tooFewQuestion) return t('questions-count.message');
    if (!isSupportedDateRange) return t('dates.message');
    return t('collection.message');
  };

  if (canUpsell) {
    return (
      <AlertContent role="alert">
        <Alert kind="info" onAction={onUpsell} actionText={t('business.action-text')}>
          {t('business.message')}
        </Alert>
      </AlertContent>
    );
  }

  return (
    <AlertContent role="alert">
      <Alert kind="info">{getInfoMessage()}</Alert>
    </AlertContent>
  );
};
